export default __webpack_public_path__ + "static/media/sad_face.d07251e8.svg";